module.exports = __webpack_public_path__ + "img/leaf.b039c21a.svg";